<div class="cv-tasks">
  @if (tasks.length === 0) {
    <p class="cv-tasks__empty">{{ 'cvImport.tasks.empty' | translate }}</p>
  }

  <mat-accordion [multi]="false">
    @for (task of tasks; track $index; let i = $index) {
      <mat-expansion-panel
        #panel
        class="cv-tasks__panel"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ task.caption || ('cvImport.tasks.untitled' | translate) }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-form-field appearance="outline" class="cv-tasks__field">
          <mat-label>{{ 'cvImport.tasks.caption' | translate }}</mat-label>
          <input
            matInput
            [ngModel]="task.caption"
            (ngModelChange)="onCaptionChange(i, $event)"
            [maxlength]="limits.TASK_CAPTION"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="cv-tasks__field">
          <mat-label>{{ 'cvImport.tasks.details' | translate }}</mat-label>
          <textarea
            matInput
            rows="4"
            [ngModel]="task.details"
            (ngModelChange)="onDetailsChange(i, $event)"
            [maxlength]="limits.TASK_DETAILS"
          ></textarea>
        </mat-form-field>

        <app-skill-select
          [editMode]="true"
          [active]="panel.expanded"
          [skillList]="skillList"
          [beraterSkills]="task.skills"
          [searchLabel]="'cvImport.fields.skillsSearch'"
          (changedBeraterSkills)="onSkillsChange(i, $event)"
        ></app-skill-select>

        <div class="cv-tasks__actions">
          <button mat-button type="button" (click)="removeTask(i)">
            <mat-icon>delete</mat-icon>
            {{ 'cvImport.tasks.remove' | translate }}
          </button>
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>

  <button
    mat-stroked-button
    type="button"
    class="cv-tasks__add"
    (click)="addTask()"
  >
    <mat-icon>add</mat-icon>
    {{ 'cvImport.tasks.add' | translate }}
  </button>
</div>
